<template>
  <div id="profile-screen" v-if="loggedInUserProfile">
    <div class="row">
      <div class="col-12">
        <h1 class="page-title">{{ $t('pages.title.profile') }}</h1>
      </div>
    </div>
    <div class="row form-row">
      <div class="col-8 offset-2">
        <div class="row header-row">
          <div class="col-6">
            <div class="profile-image-wrapper">
              <profile-image
                :user="loggedInUserProfile"
                class="profile-image"
              />
              <span class="change-image-link" @click="changeImage">{{
                $t('profile.form.gravatar')
              }}</span>
              <input
                type="file"
                style="display: none"
                ref="imageSelector"
                @change="handleFiles"
              />
            </div>
          </div>
          <div class="col-6 name-info-col">
            <div class="full-name">{{ fullName }}</div>
            <div class="user-name">{{ loggedInUserProfile.userName }}</div>
            <div class="languages">
              <!-- <img
                :class="{selected: $i18n.locale == 'hu'}"
                @click="changeLanguage('hu')"
                src="/static/images/flags/hungary.svg"
                alt="hungary"
              />-->
              <!--<img
                :class="{ selected: $i18n.locale == 'en' }"
                @click="changeLanguage('en')"
                src="/static/images/flags/united-states.svg"
                alt="united states"
              />-->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <base-input
              :placeHolder="$t('profile.form.userName')"
              @baseInputValue="valueChanged('userName', $event)"
              :text="loggedInUserProfile.userName"
              :isInvalid="!isUserNameValid && userName != null"
              :errorText="$t('profile.form.userName.errorText')"
              class="col-12"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <base-input
              :placeHolder="$t('profile.form.fistName')"
              @baseInputValue="valueChanged('firstName', $event)"
              :text="loggedInUserProfile.firstName"
              :isInvalid="!isFirstNameValid && firstName != null"
              :errorText="$t('profile.form.firstName.errorText')"
              class="col-12"
            />
          </div>
          <div class="col-6">
            <base-input
              :placeHolder="$t('profile.form.lastName')"
              @baseInputValue="valueChanged('lastName', $event)"
              :isInvalid="!isLastNameValid && lastName != null"
              :errorText="$t('profile.form.lastName.errorText')"
              :text="loggedInUserProfile.lastName"
              class="col-12"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <base-input
              :placeHolder="$t('profile.form.email')"
              @baseInputValue="valueChanged('email', $event)"
              :isInvalid="!isEmailValid && email != null"
              :errorText="$t('profile.form.email.errorText')"
              :text="loggedInUserProfile.email"
              class="col-12"
            />
          </div>
          <div class="col-6">
            <base-input
              :placeHolder="$t('profile.form.password')"
              @baseInputValue="valueChanged('password', $event)"
              :isInvalid="!isPasswordValid && password != null"
              :errorText="$t('profile.form.password.errorText')"
              :type="'password'"
              class="col-12"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 pl-5 pr-5">
            <div class="info-text" v-t="'profile.form.update.infoText'"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 timezone-col">
            <label class="timezone-label">{{
              $t('profile.form.timezone.label')
            }}</label>
            <multiselect
              v-model="timezone"
              deselect-label="Deselect"
              track-by="name"
              label="name"
              :placeholder="$t('profile.form.timezone.placeholder')"
              :options="timezoneList"
              :searchable="true"
              :allow-empty="false"
              class="timezone-select"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <strong>{{ option.name }}</strong>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="email-settings-title text-left">
              {{ $t('profile.form.update.emailSettingsTitle') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="d-flex">
              <div class="email-settings-text">
                <div class="label">
                  {{ $t('profile.form.update.feedbackNotification.title') }}
                </div>
                <div class="description">
                  {{
                    $t('profile.form.update.feedbackNotification.description')
                  }}
                </div>
              </div>
              <switcher
                v-model="emailSettings.feedbackNotification"
                class="email-settings-switcher"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <div class="email-settings-text">
                <div class="label">
                  {{ $t('profile.form.update.recommendations.title') }}
                </div>
                <div class="description">
                  {{ $t('profile.form.update.recommendations.description') }}
                </div>
              </div>
              <switcher
                v-model="emailSettings.recommendations"
                class="email-settings-switcher"
              />
            </div>
          </div>
          <div class="col-6 mt-3">
            <div class="d-flex">
              <div class="email-settings-text">
                <div class="label">
                  {{ $t('profile.form.update.weeklyReports.title') }}
                </div>
                <div class="description">
                  {{ $t('profile.form.update.weeklyReports.description') }}
                </div>
              </div>
              <switcher
                v-model="emailSettings.weeklyReports"
                class="email-settings-switcher"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 offset-3">
            <base-button @click="save" :text="$t('profile.form.buttonText')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ProfileImage from '@/components/shared/users/UserImage';
import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';
import RegistrationFormMixin from '@/components/shared/users/RegistrationFormMixin';
import Switcher from '@/components/shared/elements/Switcher';

export default {
  name: 'ProfileScreen',
  mixins: [RegistrationFormMixin],
  components: {
    ProfileImage,
    BaseInput,
    BaseButton,
    Switcher,
  },
  data() {
    return {
      firstName: undefined,
      lastName: undefined,
      userName: undefined,
      password: undefined,
      email: undefined,
      emailSettings: {},
      timezone: undefined,
    };
  },
  created() {
    this.fetchLoggedInProfile().then((x) => {
      this.firstName = x.user.firstName;
      this.lastName = x.user.lastName;
      this.userName = x.user.userName;
      this.email = x.user.email;
      this.emailSettings = { ...x.user.emailSettings };
      this.timezone = { name: x.user.timezone };
    });
  },
  computed: {
    ...mapGetters({
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
    fullName() {
      return `${this.loggedInUserProfile.firstName} ${this.loggedInUserProfile.lastName}`;
    },
    timezoneList() {
      return this.$moment.tz.names().map((name) => ({ name }));
    },
  },
  methods: {
    ...mapActions({
      fetchLoggedInProfile: 'users/fetchLoggedInProfile',
      updateUserProfile: 'users/updateUserProfile',
      uploadProfileImage: 'users/uploadProfileImage',
    }),
    ...mapMutations({
      changeLocale: 'changeLocale',
    }),
    valueChanged(propName, event) {
      this[propName] = event;
    },
    changeLanguage(languageCode) {
      this.$i18n.locale = languageCode;
      this.changeLocale(languageCode);
    },
    save() {
      if (
        this.isEmailValid &&
        this.isPasswordValid &&
        this.isFirstNameValid &&
        this.isLastNameValid &&
        this.isUserNameValid
      ) {
        this.updateUserProfile({
          userName: this.userName,
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password,
          email: this.email,
          emailSettings: this.emailSettings,
          timezone: this.timezone.name,
        })
          .then(() => {
            this.$swal(
              this.$t('profile.form.success.title'),
              this.$t('profile.form.success.message'),
              'success'
            );
          })
          .catch((err) => {
            this.$swal(
              this.$t('profile.form.error.title'),
              this.$t(`server.errors.${err.data.errorCode}`, {
                value: Object.keys(err.data.value)[0],
              }),
              'error'
            );
          });
      } else {
        this.$swal(
          this.$t('profile.form.error.title'),
          this.$t('profile.form.error.message'),
          'error'
        );
      }
    },
    changeImage() {
      this.$refs.imageSelector.click();
    },
    handleFiles(ev) {
      const file = ev.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.uploadProfileImage(formData)
        .then(() => {
          this.fetchLoggedInProfile();
        })
        .catch((err) => {
          this.$swal(
            this.$t('profile.form.error.title'),
            this.$t(`profile.form.error.message.${err.message}`),
            'error'
          );
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
#profile-screen {
  //display: flex;
  //justify-content: center;
  padding: 0 3%;
  > .row {
    width: 100%;
  }
  .profile-image-wrapper {
    height: 120px;
    width: 120px;
    margin: auto;
  }
  .change-image-link {
    color: $primary-color;
    cursor: pointer;
    font-weight: bold;
  }
  .name-info-col {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 20px;
    text-align: left;
    .full-name {
      font-size: 20px;
    }
  }
  .form-row {
    .row {
      margin: 30px 0;
    }
    .info-text {
      color: #aaa;
      font-size: 0.9rem;
      border: 1px dashed #ccc;
      border-radius: 8px;
      padding: 8px;
    }
  }
  .header-row {
    background-color: #eee;
    padding: 45px;
    border-radius: 15px;
    margin: 0 30px !important;
  }
  .languages {
    display: flex;
    justify-content: left;
    align-items: center;
    img {
      width: 35px;
      height: 35px;
      margin-right: 10px;
      cursor: pointer;
      border: 3px solid transparent;
      border-radius: 17px;
      &.selected {
        border: 3px solid $primary-hover-color;
      }
    }
  }
  .email-settings-title {
    font-size: 1.2rem;
    font-weight: bolder;
    padding-left: 15px;
  }
  .email-settings-text {
    text-align: left;
    padding-left: 15px;
    .label {
      font-weight: bold;
    }
    .description {
      color: #aaa;
      font-size: 0.9rem;
      padding-right: 10px;
    }
  }
  .timezone-col {
    text-align: left;
    padding: 0 30px;
    .timezone-label {
      font-weight: bolder;
    }
    .timezone-select {
    }
  }
}
</style>
